import styled from 'styled-components';

export const PlannerCardTop = styled.div`
  border: 1px solid var(--gray-moderate);
  border-bottom: none;
  border-radius: var(--semi-medium-border-radius)
    var(--semi-medium-border-radius) 0 0;
  padding: var(--medium-big-padding);
  display: flex;
  align-items: center;
  gap: var(--semi-medium-padding);
  background-color: var(--white-main);
`;

export const AutoScheduleBadge = styled.div`
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  background-color: rgba(125, 116, 224, 0.2);
  border-radius: var(--box-border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--security-culture-primary, var(--purple-text));
`;

export const AutoScheduleLabel = styled.span`
  font-size: var(--small-font-size);
  font-weight: 600;
  color: var(--black-main);
  display: flex;
  align-items: center;
  gap: var(--xxsmall-padding);
`;

export const AutoScheduleDescription = styled.span`
  font-size: var(--xsmall-font-size);
  color: var(--main-text-color);
`;
